




































































import Vue from 'vue';
import CloseIcon from 'vue-material-design-icons/Close.vue';
import { mapGetters } from 'vuex';
import SpeechBubbleMenu from '@/dex-shared/components/SpeechBubbleMenu.vue';

export default Vue.extend({
  components: {
    CloseIcon,
    SpeechBubbleMenu,
  },
  computed: {
    ...mapGetters({
      skillDescription: 'skillDescription',
    }),
  },
  methods: {
    toggleSkillDescription(e: Event) {
      this.$store.commit('TOGGLE_SKILL_DESCRIPTION', e);
    },
  },
});
